import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle2, XCircle, ArrowRight, RefreshCw, Clock, Package, ShoppingBag, ShieldCheck } from 'lucide-react';

export default function PaymentResultPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Đọc các tham số được truyền từ Backend qua URL redirect
  const success = searchParams.get('success') === 'true';
  const orderCode = searchParams.get('orderCode') || '';

  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center space-y-6">
      <div className="bg-white border border-slate-200 rounded-3xl p-8 sm:p-10 shadow-sm space-y-6 animate-in fade-in zoom-in duration-200">
        {success ? (
          <>
            {/* Icon thành công */}
            <div className="w-20 h-20 bg-emerald-50 text-emerald-600 rounded-3xl flex items-center justify-center mx-auto shadow-inner">
              <CheckCircle2 className="w-12 h-12" />
            </div>

            {/* Tiêu đề & Trạng thái */}
            <div className="space-y-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-amber-50 text-amber-600 border border-amber-200">
                <Clock className="w-3.5 h-3.5 animate-pulse" /> Đang xác nhận đơn
              </span>
              <h2 className="text-2xl font-black text-slate-900">Thanh toán VNPay thành công!</h2>
              <p className="text-xs text-slate-500 leading-relaxed max-w-sm mx-auto">
                Giao dịch thanh toán của bạn đã hoàn tất. Hệ thống đang tiến hành <span className="font-bold text-slate-800">xác nhận đơn hàng</span> và chuẩn bị gửi hàng cho bạn.
              </p>
            </div>

            {/* Thông tin chi tiết giao dịch */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4.5 text-xs text-left space-y-2.5">
              <div className="flex items-center justify-between pb-2 border-b border-slate-200/60">
                <span className="text-slate-500 font-medium">Mã đơn hàng:</span>
                <span className="font-extrabold text-slate-900 font-mono">#{orderCode}</span>
              </div>
              <div className="flex items-center justify-between pb-2 border-b border-slate-200/60">
                <span className="text-slate-500 font-medium">Phương thức:</span>
                <span className="font-bold text-indigo-600 flex items-center gap-1">
                  <ShieldCheck className="w-4 h-4 text-emerald-600" /> Cổng VNPay
                </span>
              </div>
              <div className="flex items-center justify-between pb-2 border-b border-slate-200/60">
                <span className="text-slate-500 font-medium">Tình trạng thanh toán:</span>
                <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 font-bold rounded-md text-[11px]">
                  Đã thanh toán
                </span>
              </div>
              <div className="flex items-center justify-between pt-0.5">
                <span className="text-slate-500 font-medium">Trạng thái đơn:</span>
                <span className="text-amber-600 font-bold flex items-center gap-1">
                  <Clock className="w-3.5 h-3.5" /> Đang xác nhận đơn
                </span>
              </div>
            </div>

            {/* Nút thao tác */}
            <div className="pt-2 space-y-2.5">
              <button 
                onClick={() => navigate(orderCode ? `/orders/${orderCode}` : '/orders')} 
                className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-bold transition flex items-center justify-center gap-2 shadow-md cursor-pointer"
              >
                <Package className="w-4 h-4" /> Xem đơn hàng của tôi <ArrowRight className="w-4 h-4" />
              </button>
              <button 
                onClick={() => navigate('/')} 
                className="w-full py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-xs font-bold transition flex items-center justify-center gap-2 cursor-pointer"
              >
                <ShoppingBag className="w-4 h-4" /> Tiếp tục mua sắm
              </button>
            </div>
          </>
        ) : (
          <>
            {/* Icon thất bại */}
            <div className="w-20 h-20 bg-rose-50 text-rose-600 rounded-3xl flex items-center justify-center mx-auto shadow-inner">
              <XCircle className="w-12 h-12" />
            </div>

            {/* Tiêu đề */}
            <div className="space-y-2">
              <h2 className="text-2xl font-black text-slate-900">Thanh toán không thành công</h2>
              <p className="text-xs text-slate-500 leading-relaxed max-w-sm mx-auto">
                Giao dịch thanh toán qua VNPay cho đơn hàng <span className="font-bold text-slate-800">#{orderCode}</span> chưa hoàn tất hoặc đã bị hủy.
              </p>
            </div>

            {/* Nút thao tác thử lại */}
            <div className="pt-2 space-y-2.5">
              <button 
                onClick={() => navigate('/checkout')} 
                className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-bold transition flex items-center justify-center gap-2 shadow-md cursor-pointer"
              >
                <RefreshCw className="w-4 h-4" /> Thử lại thanh toán
              </button>
              <button 
                onClick={() => navigate('/')} 
                className="w-full py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-xs font-bold transition flex items-center justify-center gap-2 cursor-pointer"
              >
                <ShoppingBag className="w-4 h-4" /> Quay về trang chủ
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}